import { BaseHelpers } from '@sda/sdk/helpers/firestore.helpers/base.helpers';

export class SDKOptions {
  static BaseFirestoreHelpers: any = BaseHelpers;
}
